<div class="resume-page">
    <div class="container" style="height:100%">
        <iframe
            src="https://drive.google.com/file/d/1_RflTcrLRA2xnk0Vd4HzXTV12NTw6KGz/preview"
            width="100%"
            height="100%"
        >
        </iframe>
    </div>
</div>